import React from 'react';

export const RejectedIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_4568_11111"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="25"
        height="25"
      >
        <rect
          x="0.373047"
          y="-0.223389"
          width="24"
          height="24"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_4568_11111)">
        <path
          d="M6.37305 21.7766C5.82305 21.7766 5.35221 21.5808 4.96055 21.1891C4.56888 20.7974 4.37305 20.3266 4.37305 19.7766V3.77661C4.37305 3.22661 4.56888 2.75578 4.96055 2.36411C5.35221 1.97244 5.82305 1.77661 6.37305 1.77661H14.373L20.373 7.77661V11.9999L19.4991 10.9999L16.4991 13.9999L13.9991 10.9999L9.99915 14.4999L12.9991 17.4999L9.99915 20.4999L11.4991 21.7766H6.37305ZM13.373 8.77661H18.373L13.373 3.77661V8.77661Z"
          fill="#C4964D"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.5 15.8125L13.6875 13L12 14.6875L14.8125 17.5L12 20.3125L13.6875 22L16.5 19.1875L19.3125 22L21 20.3125L18.1875 17.5L21 14.6875L19.3125 13L16.5 15.8125Z"
          fill="#C4964D"
        />
      </g>
    </svg>
  );
};
